import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SearchableEnumPickerField } from './SearchableEnumPickerField';

export const SearchableEnumPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SearchableEnumPicker',
    component: SearchableEnumPickerField,
  }),
);
